var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownFromBracketSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94419 14.7211C7.53013 15.2582 8.48169 15.2582 9.06763 14.7211L15.0676 9.22108C15.6536 8.68397 15.6536 7.81171 15.0676 7.2746C14.4817 6.73749 13.5301 6.73749 12.9442 7.2746L9.50357 10.4285L9.50357 1.37499C9.50357 0.614439 8.83325 -1.38863e-05 8.00357 -1.39528e-05C7.17388 -1.40192e-05 6.50357 0.614439 6.50357 1.37499L6.50357 10.4285L3.06294 7.2746C2.477 6.73749 1.52544 6.73749 0.939502 7.2746C0.353564 7.8117 0.353564 8.68397 0.939501 9.22108L6.9395 14.7211L6.94419 14.7211Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFromBracketSolid);
export default __webpack_public_path__ + "static/media/arrow-down-from-bracket-solid.d2f9dc6944b79df63a94583e2b3e0385.svg";
export { ForwardRef as ReactComponent };